module.exports = __webpack_public_path__ + "794cde82988a63d4b105756ec339ee7b.png";